import { Activity, AlertTriangle } from 'lucide-react';

export interface StatusMetric {
  label: string;
  value: string;
  trend: string;
  status: 'success' | 'warning';
}

export interface SecurityEvent {
  id: string;
  type: string;
  title: string;
  description: string;
  timestamp: string;
  icon: typeof Activity;
  severity: 'high' | 'medium' | 'low';
}

export interface SystemMetric {
  name: string;
  value: number;
  status: 'normal' | 'warning';
}

export interface Monitor {
  name: string;
  status: 'healthy' | 'warning';
  count: number;
}

export const statusMetrics: StatusMetric[] = [
  { label: 'Discovered Assets', value: '342', trend: '+5', status: 'success' },
  { label: 'Critical Exposures', value: '8', trend: '-2', status: 'warning' },
  { label: 'Shadow IT', value: '15', trend: '+3', status: 'warning' },
  { label: 'Risk Score', value: '685', trend: '-12', status: 'success' }
];

export const securityEvents: SecurityEvent[] = [
  {
    id: '1',
    type: 'exposure',
    title: 'Exposed Database Instance',
    description: 'MongoDB instance accessible from internet at prod-db.company.com',
    timestamp: '5 min ago',
    icon: AlertTriangle,
    severity: 'high'
  },
  {
    id: '2',
    type: 'exposure',
    title: 'SSL Certificate Expiring',
    description: 'api.company.com certificate expires in 5 days',
    timestamp: '10 min ago',
    icon: AlertTriangle,
    severity: 'medium'
  },
  {
    id: '3',
    type: 'exposure',
    title: 'Open Git Repository',
    description: 'Public access to git repo at dev.company.com/repo',
    timestamp: '15 min ago',
    icon: AlertTriangle,
    severity: 'high'
  }
];

export const systemMetrics: SystemMetric[] = [
  { name: 'Assets with Critical CVEs', value: 12, status: 'warning' },
  { name: 'Exposed Services', value: 28, status: 'warning' },
  { name: 'Domain Security Score', value: 85, status: 'normal' }
];

export const activeMonitors: Monitor[] = [
  { name: 'Domain Discovery', status: 'healthy', count: 156 },
  { name: 'Cloud Asset Scanner', status: 'warning', count: 89 },
  { name: 'Service Enumeration', status: 'healthy', count: 342 },
  { name: 'SSL Certificate Monitor', status: 'healthy', count: 245 },
  { name: 'Vulnerability Scanner', status: 'warning', count: 178 },
  { name: 'Shadow IT Detection', status: 'healthy', count: 412 }
];